import { actionShowModal, actionHideModal } from 'react-redux-app/lib/modules/modal/actions';

import { MODAL_DIALOG__DELETE_ACCOUNT } from '../../constants/dialogs';


export const actionShowDeleteAccountDialog = () => dispatch => (
  dispatch(actionShowModal(MODAL_DIALOG__DELETE_ACCOUNT))
);

export const actionHideDeleteAccountDialog = () => dispatch => (
  dispatch(actionHideModal(MODAL_DIALOG__DELETE_ACCOUNT))
);
